export enum RoomType {
    Bedroom = 1,
    Livingroom,
    Kitchen,
    Bathroom,
    Other
}